import {
  GET_EXTERNAL_PROJECTS_LIST_LOADING,
  GET_EXTERNAL_PROJECTS_LIST_SUCCESS,
  GET_EXTERNAL_PROJECTS_LIST_FAILURE,
} from "redux/types";

const initialState = {
  getExternalProjectsListLoading: false,
  externalProjectsListData: null,
  errors: null,
};

export const getExternalProjectsListReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case GET_EXTERNAL_PROJECTS_LIST_LOADING:
      return { ...state, getExternalProjectsListLoading: action.payload };
    case GET_EXTERNAL_PROJECTS_LIST_SUCCESS:
      return { ...state, externalProjectsListData: action.payload };
    case GET_EXTERNAL_PROJECTS_LIST_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
